import React, { Component } from 'react';
import { ButtonToolbar, ToggleButton, ToggleButtonGroup } from 'react-bootstrap';

export default class FilterToolbar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.defaultValues
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.items !== this.props.items) {
            //this.setState({ value: [] });
        }
    }

    handleChange = (value) => {

        this.setState({ value });

        var filter = [];
        for (var v in value) {
            filter.push(this.props.items[value[v]]);
        }
        this.props.onToggle(filter);
    }

    renderButtons() {
        if (this.props.items.length === 0) return [];

        return this.props.items.map((item, i) => (
            <ToggleButton key={i} value={i}>{item}</ToggleButton>
        ));
    }

    render() {
        return (
            <ToggleButtonGroup className="filter-btn-group" type="checkbox" value={this.state.value} onChange={this.handleChange}>
                {this.renderButtons()}
            </ToggleButtonGroup>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Misc/FilterToolbar.js